import { format } from 'date-fns';

type OMSReservationConditionProps = {
  overlapCSOnCallShiftEnd: string | null;
  overlapCSOnCallShiftStart: string | null;
  overlapPhoneSupportShiftEnd: string | null;
  overlapPhoneSupportShiftStart: string | null;
};

const formatStr = 'HH:mm MM/dd/yyyy zzz';
const formatDateStr = (dateStr: string | null) => (dateStr ? format(new Date(dateStr), formatStr) : '-');

export const OMSReservationCondition = ({
  overlapCSOnCallShiftStart,
  overlapCSOnCallShiftEnd,
  overlapPhoneSupportShiftStart,
  overlapPhoneSupportShiftEnd,
}: OMSReservationConditionProps) => {
  const hasCsOverlap = overlapCSOnCallShiftStart || overlapCSOnCallShiftEnd;
  const hasPhoneSupportOverlap = overlapPhoneSupportShiftStart || overlapPhoneSupportShiftEnd;

  if (!hasCsOverlap && !hasPhoneSupportOverlap) return '-';

  return (
    <div className="flex flex-col gap-2">
      {hasCsOverlap && (
        <div>
          <div>Overlap with Clinical Specialist</div>
          <div>{formatDateStr(overlapCSOnCallShiftStart)}</div>
          <div>{formatDateStr(overlapCSOnCallShiftEnd)}</div>
        </div>
      )}
      {hasPhoneSupportOverlap && (
        <div>
          <div>Overlap with Clinical Lead</div>
          <div>{formatDateStr(overlapPhoneSupportShiftStart)}</div>
          <div>{formatDateStr(overlapPhoneSupportShiftEnd)}</div>
        </div>
      )}
    </div>
  );
};
